// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: WLg0i0UB0fg
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ListElement from "../../ListElement"; // plasmic-import: gZQS8RDUPA/component

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicNoteList.module.css"; // plasmic-import: WLg0i0UB0fg/css

export type PlasmicNoteList__VariantMembers = {
  state: "empty";
};

export type PlasmicNoteList__VariantsArgs = {
  state?: MultiChoiceArg<"empty">;
};

type VariantPropType = keyof PlasmicNoteList__VariantsArgs;
export const PlasmicNoteList__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicNoteList__ArgsType = {};
type ArgPropType = keyof PlasmicNoteList__ArgsType;
export const PlasmicNoteList__ArgProps = new Array<ArgPropType>();

export type PlasmicNoteList__OverridesType = {
  root?: p.Flex<"div">;
  noteList?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultNoteListProps {
  state?: MultiChoiceArg<"empty">;
  className?: string;
}

function PlasmicNoteList__RenderFunc(props: {
  variants: PlasmicNoteList__VariantsArgs;
  args: PlasmicNoteList__ArgsType;
  overrides: PlasmicNoteList__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    true ? (
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens,
          sty.root,
          { [sty.rootstate_empty]: hasVariant(variants, "state", "empty") }
        )}
      >
        {(hasVariant(variants, "state", "empty") ? true : true) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"noteList"}
            data-plasmic-override={overrides.noteList}
            hasGap={true}
            className={classNames(projectcss.all, sty.noteList, {
              [sty.noteListstate_empty]: hasVariant(variants, "state", "empty")
            })}
          >
            <ListElement
              className={classNames("__wab_instance", sty.listElement__kEwdR)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__kacTg)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__ps1Kz)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__ju3Hk)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__tZsmz)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__rVkge)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__mSl6)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__lIhbg)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__jCwKu)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__ysgTb)}
            >
              {"Enter some text"}
            </ListElement>

            <ListElement
              className={classNames("__wab_instance", sty.listElement__qcFj)}
            >
              {"Enter some text"}
            </ListElement>
          </p.Stack>
        ) : null}
        {(hasVariant(variants, "state", "empty") ? true : true) ? (
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames(projectcss.all, sty.freeBox, {
              [sty.freeBoxstate_empty]: hasVariant(variants, "state", "empty")
            })}
          >
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___1Qj37,
                {
                  [sty.textstate_empty___1Qj3793Fsu]: hasVariant(
                    variants,
                    "state",
                    "empty"
                  )
                }
              )}
            >
              {"Empty List"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__mwtEl,
                {
                  [sty.textstate_empty__mwtEl93Fsu]: hasVariant(
                    variants,
                    "state",
                    "empty"
                  )
                }
              )}
            >
              {"Double-click on the model to create a note"}
            </div>
          </div>
        ) : null}
      </div>
    ) : null
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "noteList", "freeBox"],
  noteList: ["noteList"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  noteList: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicNoteList__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicNoteList__VariantsArgs;
    args?: PlasmicNoteList__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicNoteList__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicNoteList__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicNoteList__ArgProps,
          internalVariantPropNames: PlasmicNoteList__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicNoteList__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicNoteList";
  } else {
    func.displayName = `PlasmicNoteList.${nodeName}`;
  }
  return func;
}

export const PlasmicNoteList = Object.assign(
  // Top-level PlasmicNoteList renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    noteList: makeNodeComponent("noteList"),
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicNoteList
    internalVariantProps: PlasmicNoteList__VariantProps,
    internalArgProps: PlasmicNoteList__ArgProps
  }
);

export default PlasmicNoteList;
/* prettier-ignore-end */
